import Client from '../../../services/client';
import type { ConfirmPaymentInfo } from '../../../types';

interface ConfirmJkoPayTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmJkoPayTransaction = async ({
  confirmPaymentInfo,
}: ConfirmJkoPayTransactionProps) => {
  const { data } = await Client.authApsWalletPay({
    transactionId: confirmPaymentInfo.merchantTransactionId,
    walletType: 'jkopay',
  });

  return data;
};
